import { IconChevronRight } from 'featherico';
import { map, truncate } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { BASE } from '../../../routes';
import { preventJavascriptUrls } from '../../../services/security';
import Tooltip from '../Tooltip';
import styles from './style.m.less';

const propTypes = {
    path: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            url: PropTypes.string,
            prependBaseUrl: PropTypes.bool,
        })
    ).isRequired,
};

const TRUNCATE_LENGTH = 45;
const withTooltip = (element, tooltip) => (
    <Tooltip tooltip={tooltip} position="bottom">
        {element}
    </Tooltip>
);

export default function Breadcrumbs(props) {
    return (
        <ul className={styles.container}>
            {map(
                item => (
                    <Breadcrumb {...item} key={item.label} />
                ),
                props.path
            )}
        </ul>
    );
}

Breadcrumbs.propTypes = propTypes;

function Breadcrumb({ prependBaseUrl, url, label }) {
    const isLong = label.length > TRUNCATE_LENGTH;
    const displayLabel = isLong ? truncate({ length: TRUNCATE_LENGTH }, label) : label;

    const contentProps = {
        prependBaseUrl,
        url,
        displayLabel,
    };
    return (
        <li>
            {isLong ? (
                withTooltip(<BreadcrumbContent {...contentProps} />, label)
            ) : (
                <BreadcrumbContent {...contentProps} />
            )}
        </li>
    );
}

function BreadcrumbContent({ prependBaseUrl, url, displayLabel }) {
    return url ? (
        <Fragment>
            <a href={preventJavascriptUrls(`${prependBaseUrl ? BASE : ''}${url}`)}>{displayLabel}</a>
            <IconChevronRight className={styles.chevron} />
        </Fragment>
    ) : (
        <span>{displayLabel}</span>
    );
}
